module.exports = __webpack_public_path__ + "img/innovacion_msh.1482c134.jpg";